import { useQuery } from '@tanstack/react-query'
import type { DocsPage } from './docsTypes'

function pageUrl(slug: string) {
  if (slug === '') {
    return '/docs-data/pages/index.json'
  }
  return `/docs-data/pages/${slug}/index.json`
}

async function fetchDocsPage(slug: string): Promise<DocsPage> {
  const response = await fetch(pageUrl(slug))
  if (!response.ok) {
    throw new Error('Page not found')
  }
  return response.json() as Promise<DocsPage>
}

export function useDocsPage(slug: string) {
  return useQuery({
    // v2: page JSON lives at pages/{slug}/index.json (not pages/{slug}.json)
    queryKey: ['docs-page', 'v2', slug],
    queryFn: () => fetchDocsPage(slug),
    staleTime: Infinity,
    retry: false,
  })
}
